export default __webpack_public_path__ + "static/service_03-457793e3163b7b39478a9bd748386b20.jpg";